import React, { useState } from "react";
import { Box, Button, Card, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff, LockOutlined, MailOutlined, PersonOutlined } from "@mui/icons-material";
import myImage from './assets/MyImg/logo.png'; // Ensure you replace this path with your actual image location.
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { useNavigate } from "react-router-dom";

const LoginSignupPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleSignup = async () => {
    try {
      const response = await fetch("https://enzo-matr.onrender.com/api/admin/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, email, password }),
      });

      if (response.ok) {
        alert("Admin data stored successfully");
        navigate("/admin-login");
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      alert("Failed to store admin data. Please try again.");
    }
  };

  return (
    
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "100vw",
        minHeight: "100vh",
        backgroundColor: "#eaeaee",
        overflow: "hidden",
        position: "relative",
       
      }}
    >
      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          maxWidth: "900px",
          height: "450px",
          boxShadow: 5,
          backgroundColor: "#25bdbe",
          borderRadius: 4,
          overflow: "hidden",
          position: "relative",
          zIndex: 6,
        }}
      >
        {/* Login Section */}
        <Box
          sx={{
            flex: 1,
            order:1,
           
            backgroundColor: "white",
            padding: 3,
            textAlign: "center",
            width: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: "#333",
            borderRadius: "15px",
            boxShadow: "8px 5px 20px rgba(0, 0, 0, 0.5)",
            zIndex: 6,
            position: "relative",
          }}
        >

            
          <Box sx={{ display: "flex",alignItems: "center", justifyContent: "center", gap: 1 }}>
           <Box> <img
              src={myImage}
              alt="Login Logo"
              style={{
                position: "relative",
                width: "260px",       // Change width size
                height: "100px",
                marginTop: "-120px",
                marginLeft:"-40px",      // Change height size
                borderRadius: "8px"   // Optional rounded corners
              }} 
            /></Box>
            {/* <Typography variant="h3" sx={{ fontWeight: "bold",ml:"70px",position:"absolute", fontSize: 60, fontFamily: "'Poppins', sans-serif" }}>
              Enzo
            </Typography> */}
          </Box>

          <Typography variant="h5" sx={{ mt: 5,color:"black", fontSize: 25, fontWeight: "bold", fontFamily:"Caladea" }}>
            WELCOME BACK!
          </Typography>
          <Typography variant="body1" sx={{ mt: 1,fontSize: 10, color: "black",fontWeight: "bold",fontFamily:"montserrat" }}>
            To continue Login your <br /> Account
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#FF8C00",
              width: "50%",
              textTransform: "none",
              marginLeft: "25%",
              color: "white",
              fontWeight: "bold",
              fontFamily:"montserrat",
              '&:hover': { backgroundColor: "#E67E22" },
            }}onClick={() => navigate("/login")}
          >
          Login
          </Button>
        </Box>

        {/* Signup Section */}
        <Box
          sx={{
            flex: 1,
            order:2,
            backgroundColor: "#25bdbe",
            padding: 3,
            textAlign: "center",
            color: "white",
            borderRadius: "0 8px 8px 0",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold", background: "white", width: 150, p: 0.3, ml: 17, borderRadius: 2, color: "black", fontSize: 22,fontFamily:"Caladea" }}>
            ADMIN
          </Typography>
          <Typography variant="h6" sx={{ mt: 1, fontWeight: "bold", fontSize: 28,fontFamily:"Caladea" }}>
            Sign  up  to  Your  Account
          </Typography>
          <Typography variant="body2" sx={{ mt: 0, color: "white", fontWeight: "bold",fontSize: 12, fontFamily:"montserrat" }}>
            Login Using
          </Typography>

          <Box sx={{ mt: 0, ml: 6,width: "350px", }}>
            <TextField
              
              width="20px"

              size="small"
              variant="outlined"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlined sx={{ color: "gray" }} />
                  </InputAdornment>
                ),
              }}
              inputProps={{ style: { fontWeight: "bold",color:"black" ,fontFamily:"caladea"} }}
              sx={{ mt: 2,ml:"-20px", backgroundColor: "white", borderRadius: 1,width: "300px", fontWeight: "bold" }}
            />
            <TextField
              
              size="small"
              variant="outlined"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MailOutlined sx={{ color: "gray" }} />
                  </InputAdornment>
                ),
              }}
              inputProps={{ style: { fontWeight: "bold",fontFamily:"caladea" } }}
              sx={{ mt: 2, ml:"-20px",backgroundColor: "white", borderRadius: 1,width: "300px"}}  
            />
            <TextField
             
              size="small"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlined sx={{ color: "gray" }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              inputProps={{ style: { fontWeight: "bold",fontFamily:"Caladea" } }}
              sx={{ mt: 2,ml:"-20px", backgroundColor: "white", borderRadius: 1,width: "300px" }}  
            />

            <Button
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                width: "50%",
                borderRadius: 3,
                fontWeight: "bold",
                backgroundColor: "black",
                fontFamily:"montserrat",
                textTransform: "none",
                color: "white",
                '&:hover': { backgroundColor: "#333" },
              }}onClick={handleSignup}
            >
              Sign Up
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default LoginSignupPage;
